export default __webpack_public_path__ + "media/images/blog/blog-01-770x520-3ed7c8afae748a30006001a08372738a.jpg";